document.addEventListener("DOMContentLoaded", function() {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.fatimaLazy"));

  lazyVideos.forEach(function(video) {
    var sources = video.querySelectorAll("source");
    sources.forEach(function(source) {
      if (source.dataset.src) {
        source.src = source.dataset.src;
      }
    });

    video.load();
    video.classList.remove("fatimaLazy");
  });
});

initslide();

$(document).on('shopify:section:load', function(event) {
  initslide();
});

$(document).on('shopify:section:unload', function(event) {
  initslide();
});

function initslide() {
     $('.mcollection-list').slick({
    infinite: false,
    speed: 400,
    autoplay: false,
    slidesToShow: 7,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
      responsive: [ 
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5
        }
      },
       {
        breakpoint: 800,
        settings: {
          slidesToShow: 3
        }
      },
       {
        breakpoint: 450,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
   $('.M-testimonial-slider').slick({
    infinite: true,
    speed: 400,
    autoplay: true,
    slidesToShow: 3,
    pauseOnHover: false,
    slidesToScroll: 1,
    arrows: false,
    centerMode: true,
    centerPadding: '0px',
    autoplaySpeed: 5000,
    dots: true,
      responsive: [ 
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
       {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}

function isElementMovedUpAndOutOfViewport(el) {
  var rect = el.getBoundingClientRect();
  return (
      rect.bottom <= 0 &&
      rect.top < window.innerHeight
  );
}

function checkVisibility() {
  let ogPaymentElement = document.querySelector("#buy_button");
  let stickyatc = document.querySelector(".sticky-atc-wrapper");
  if (isElementMovedUpAndOutOfViewport(ogPaymentElement)) {
      stickyatc.classList.add("mvisible");
  } else {
      stickyatc.classList.remove("mvisible");
  }
}  
window.addEventListener("scroll", checkVisibility);
window.addEventListener("resize", checkVisibility); // Listen for window resize
checkVisibility();